import { useEffect, useState } from 'react'

// true cuando la media query casa. Arranca en `false` y se corrige en el efecto; para estados
// visuales que ya resuelve el CSS esto no parpadea, solo ajusta el comportamiento JS asociado.
// (Espejo de professional-area/src/lib/use-media-query.ts.)
const useMediaQuery = (query) => {
	const [matches, setMatches] = useState(false)

	useEffect(() => {
		if (!window.matchMedia) return undefined
		const mq = window.matchMedia(query)
		setMatches(mq.matches)
		const onChange = (event) => setMatches(event.matches)
		mq.addEventListener('change', onChange)
		return () => mq.removeEventListener('change', onChange)
	}, [query])

	return matches
}

export default useMediaQuery
